import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'removeHtmlTags'
})
export class RemoveHtmlTagsPipe implements PipeTransform {
  transform(strHtmlCode: string) {
    return strHtmlCode.replace(/<\/?[^>]+(>|$)/g, '');
  }
}
